import { Config, colors, animals } from 'unique-names-generator';

export const nameConfig: Config = {
  dictionaries: [colors, animals],
  separator: ' ',
  length: 2,
  style: 'capital' as const,
};
